"use client";

import Link from "next/link";
import {
  FacebookIcon,
  FacebookIconDark,
  InstagramIcon,
  InstagramIconDark,
  Logo,
  LogoMobile,
  TwitterIcon,
  TwitterIconDark,
  BlackLogo,
  BlackLogoMobile,
} from "@icons/svgs";
import styles from "@styles/footer.module.css";
import {
  footerItemsOne,
  footerItemsTwo,
  footerItemsThree,
} from "./FooterItems";
import { usePathname } from "next/navigation";

const facebookURL = "http://facebook.com/theoicnm/";
const instagramURL = "https://www.instagram.com/theoicnm/";
const twitterURL = "https://twitter.com/theoicnm";

const light_footer: string[] = [
  "/plagiarism-policy",
  "/website-policy",
  "/refund-policy",
  "/privacy-policy",
  "/study-guide",
  "/conflict-resolution",
];

const excludedPaths: string[] = [
  // "/landing/natural-medicine-pathway",
  "/test-admission-letter",
  "/dashboard/admission-letter",
];

export function Footer() {
  const pathname = usePathname() || "";

  // 2. Logic without hooks (Derived State)
  if (excludedPaths.includes(pathname)) return null;

  const isLight = light_footer.includes(pathname);
  const dark = !isLight;
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div
        style={{ backgroundColor: dark ? "#006838" : "#F4F9EC" }}
        className={styles.footer_container}
      >
        <div className={styles.footer_top}>
          <div className={styles.footer_top_left}>
            <Link
              href="/"
              aria-label="Olive International College of Natural Medicine — home"
            >
              {dark ? (
                <>
                  <div className="hidden md:block">
                    <Logo />
                  </div>
                  <div className="md:hidden">
                    <LogoMobile />
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  <div className="hidden md:block">
                    <BlackLogo />
                  </div>
                  <div className="md:hidden">
                    <BlackLogoMobile />
                  </div>
                </>
              )}
            </Link>
            <p style={{ color: dark ? "#fff" : "#006838" }}>
              We&apos;re a premier institution dedicated to excellence in
              naturopathic education, emphasizing compassion and integrity. Our
              expert faculty provides a comprehensive, hands-on experience,
              nurturing both knowledge and empathy.{" "}
            </p>
            <div className={styles.socials}>
              <div
                style={{ border: dark ? "" : "1px solid #006838" }}
                className={styles.iconBox}
              >
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={facebookURL}
                  aria-label="OICNM on Facebook (opens in a new tab)"
                >
                  {dark ? (
                    <FacebookIcon className={styles.icon} />
                  ) : (
                    <FacebookIconDark className={styles.darkIcon} />
                  )}
                </Link>
              </div>
              <div
                style={{ border: dark ? "" : "1px solid #006838" }}
                className={styles.iconBox}
              >
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={instagramURL}
                  aria-label="OICNM on Instagram (opens in a new tab)"
                >
                  {dark ? (
                    <InstagramIcon className={styles.icon} />
                  ) : (
                    <InstagramIconDark className={styles.darkIcon} />
                  )}
                </Link>
              </div>
              <div
                style={{ border: dark ? "" : "1px solid #006838" }}
                className={styles.iconBox}
              >
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={twitterURL}
                  aria-label="OICNM on X (Twitter) (opens in a new tab)"
                >
                  {dark ? (
                    <TwitterIcon className={styles.icon} />
                  ) : (
                    <TwitterIconDark className={styles.darkIcon} />
                  )}
                </Link>
              </div>
            </div>
          </div>
          <ul>
            {footerItemsOne.map((item) => {
              return (
                <li key={item.title}>
                  {item.title === "Gallery" ? (
                    <Link
                      style={{ color: dark ? "#fff" : "#006838" }}
                      href={`${item.link}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <Link
                      style={{ color: dark ? "#fff" : "#006838" }}
                      href={`${item.link}`}
                    >
                      {item.title}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
          <ul>
            {footerItemsTwo.map((item) => {
              return (
                <li key={item.title}>
                  <Link
                    style={{ color: dark ? "#fff" : "#006838" }}
                    href={`${item.link}`}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul>
            {footerItemsThree.map((item) => {
              return (
                <li key={item.title}>
                  <Link
                    style={{ color: dark ? "#fff" : "#006838" }}
                    href={`${item.link}`}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.footer_bottom}>
          <span>
            Copyright © {currentYear} Olive International College of Natural
            Medicine. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
